import { CartAddEvent } from '@theme/events';

/**
 * Straight to checkout (theme setting "Go straight to checkout").
 *
 * Every add-to-cart in the theme — the product page, its sticky bar, quick add
 * and the home page buy box — announces a successful add with a CartAddEvent.
 * Once the item is in the cart, the shopper is sent on to checkout instead of
 * seeing the cart. The add itself still happens first, so the store's
 * add-to-cart events and tracking are unchanged.
 *
 * Quantity changes made inside the cart share the event's name but are a
 * different event, and an add that failed is flagged; neither redirects.
 */
document.addEventListener(CartAddEvent.eventName, (event) => {
  if (!(event instanceof CartAddEvent)) return;
  if (event.detail?.data?.didError) return;

  window.location.assign('/checkout');
});
